import * as React from 'react';

const TitleSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="title_svg__eds-icon--title_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="title_svg__eds-icon--title_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M2 21h20v1H2v-1zM4 2v3h1V3h7v15h-2v1h5v-1h-2V3h7v2h1V2H4z"
        />
    </svg>
);

TitleSvg.displayName = 'TitleSvg';
export default TitleSvg;
